import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createObjectURLCache } from './objectURLCache';

// Dimensions are used to create a key.
// Cache is invalidated when different dimensions are provided.
export const getCacheKey = (id, mode) => {
  const resizeMode = mode || 'crop';
  return [id, resizeMode].join('-');
};
export class CardPreviewCacheImpl {
  constructor(previewCache) {
    _defineProperty(this, "get", (id, mode) => {
      const cacheKey = getCacheKey(id, mode);
      return this.previewCache.get(cacheKey);
    });
    _defineProperty(this, "set", (id, mode, cardPreview) => {
      const cacheKey = getCacheKey(id, mode);
      this.previewCache.set(cacheKey, cardPreview);
    });
    _defineProperty(this, "remove", (id, mode) => {
      const cacheKey = getCacheKey(id, mode);
      this.previewCache.remove(cacheKey);
    });
    _defineProperty(this, "clear", () => {
      this.previewCache.clear();
    });
    this.previewCache = previewCache;
  }
}
export const mediaFilePreviewCache = new CardPreviewCacheImpl(createObjectURLCache());